import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { HOME_BANNER_EXPANDED_STORAGE_KEY } from '@/modules/networks/lib/constants';
import { useWhitelistOverlay } from '@/modules/whitelist/hooks/use-whitelist-overlay';
export function useHomepageBanner() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      deserializer(value) {
        return value !== "false";
      },
      initializeWithValue: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [isExpanded, setIsExpanded] = useLocalStorage(HOME_BANNER_EXPANDED_STORAGE_KEY, true, t0);
  const collapsibleElement = useRef(null);
  let t1;
  if ($[1] !== setIsExpanded) {
    t1 = value_0 => {
      setIsExpanded(value_0);
    };
    $[1] = setIsExpanded;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleIsExpanded = t1;
  const showWhitelistOverlay = useWhitelistOverlay();
  const t2 = showWhitelistOverlay ? false : isExpanded;
  let t3;
  if ($[3] !== handleIsExpanded || $[4] !== showWhitelistOverlay || $[5] !== t2) {
    t3 = {
      isExpanded: t2,
      collapsibleElement,
      handleIsExpanded,
      showWhitelistOverlay
    };
    $[3] = handleIsExpanded;
    $[4] = showWhitelistOverlay;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}